import classNames from 'classnames';
import { HTMLAttributes, ReactNode } from 'react';

import styles from './slideContainer.module.scss';

type SlideContainerProps = {
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export function SlideContainer({
  children,
  className,
  ...props
}: SlideContainerProps): JSX.Element {
  return (
    <div {...props} className={classNames(styles.slideContainer, className)}>
      <div className={styles.slideContent}>{children}</div>
    </div>
  );
}
